import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { MainCartService } from '@services/main-cart.service';

@Injectable({
    providedIn: 'root',
})
export class EventsService {
    public renderer: Renderer2;

    public constructor(
        @Inject(DOCUMENT) protected document,
        protected cartService: MainCartService,
        private rendererFactory2: RendererFactory2,
    ) {
        this.renderer = this.rendererFactory2.createRenderer(null, null);
        this.renderer.listen('document', 'addProduct', (event) => {
            if (event instanceof CustomEvent && event.detail?.gencode) {
                this.cartService.addProductByGencode(event.detail.gencode).subscribe(
                    (product) => {
                        console.log(`${product.name} (${product.gencode}) added`);
                    },
                    (error) => console.error(error),
                );
            } else {
                console.error('Gencode required in detail param');
            }
            console.log('rendererFactory2', event);
        });
    }

    /**
     * Dispacth event in DOM document
     * @param name name of event
     * @param data data to send in event
     */
    public launch(name, data): void {
        this.document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: data }));
    }
}
